import createMetadataAPIReducer from '../../utils/api-metadata-reducer';
import createMetadataAPIOperations from '../../utils/api-metadata-operations';
import createMetadataAPISelectors from '../../utils/api-metadata-selectors';
import * as currentUserTypes from '../current-user/types';

// exporting this so current-user has access to the transform function
export const options = {
  name: 'users',
  baseType: 'USERS',
  apiEndpoint: 'users',
  transform: t => ({
    ...t,
    full_name: t.first_name + ' ' + t.last_name,
    email: t.email || null,
    phone_numbers: t.phone_numbers || [],
    email_addresses: t.email_addresses || [],
    addresses: []
  })
};

const operations = createMetadataAPIOperations(options);
const selectors = createMetadataAPISelectors(options);

export { operations, selectors };

const defaultReducer = createMetadataAPIReducer(options);

// Extend the default reducer to make sure that whenever the current user is
// fetched, it is also stored in the standard list of users
export default (state, action) => {
  state = defaultReducer(state, action);
  switch (action.type) {
    case currentUserTypes.CURRENT_USER_RECEIVED: {
      const currentUser = options.transform(action.payload.currentUser);
      return {
        ...state,
        byId: {
          ...state.byId,
          [currentUser.id]: currentUser
        }
      };
    }
    default: {
      return state;
    }
  }
};
